<template>
  <div>
    <b-form-checkbox
      v-if="type == voteTypes.nsp"
      size="lg"
      :value="voteTypes.nsp"
      :unchecked-value="null"
      :checked="resolutionVoteData ? resolutionVoteData.vote : null"
      :disabled="disabled"
      @change="updateResolutionVote('vote', $event)"
    />
    <b-form-checkbox
      v-else-if="type == voteTypes.for"
      size="lg"
      :value="voteTypes.for"
      :unchecked-value="null"
      :checked="resolutionVoteData ? resolutionVoteData.vote : null"
      :disabled="disabled"
      @change="updateResolutionVote('vote', $event)"
    />
    <b-form-checkbox
      v-else-if="type == voteTypes.against"
      size="lg"
      :value="voteTypes.against"
      :unchecked-value="null"
      :checked="resolutionVoteData ? resolutionVoteData.vote : null"
      :disabled="disabled"
      @change="updateResolutionVote('vote', $event)"
    />
    <b-form-checkbox
      v-else-if="type == voteTypes.abstain"
      size="lg"
      :value="voteTypes.abstain"
      :unchecked-value="null"
      :checked="resolutionVoteData ? resolutionVoteData.vote : null"
      :disabled="disabled"
      @change="updateResolutionVote('vote', $event)"
    />

    <b-button
      v-if="
        !disabled &&
        showSelectAllRepresentedVotesButton &&
        presentParticipant &&
        representsOtherMandates &&
        (resolutionVoteData ? resolutionVoteData.vote == type : false)
      "
      size="sm"
      class="text-nowrap"
      variant="info"
      @click="selectAllRepresentedVotes(type)"
    >
      {{ $t("general.Tous") }} <font-awesome-icon icon="check-square" />
    </b-button>
  </div>
</template>

<script>
import ResolutionVoteMW from "@/middlewares/ResolutionVote";
import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";
import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingCorrespondenceVoteORM from "@/store/orm-axios/models/MeetingCorrespondenceVote";
import MeetingCorrespondenceVoteMW from "@/middlewares/MeetingCorrespondenceVote";
import { mandatePresenceStatuses } from "@/constants/mandate.js";

export default {
  props: {
    type: {
      type: Number,
      default: null,
    },
    mainMandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    currentResolution: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showSelectAllRepresentedVotesButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mainMandateData: {},
      resolutionVoteData: {},
      presentParticipant: false,
      representsOtherMandates: false,
      mandatePresenceStatuses,
    };
  },
  computed: {
    resolutionVote() {
      return ResolutionVoteORM.getters("getResolutionVoteByMandateAndResolution")(
        this.mainMandateData.id,
        this.currentResolution.id
      );
    },
    meetingCorrespondenceVotes() {
      return MeetingCorrespondenceVoteORM.query()
        .where("mandate_id", this.mainMandateData.id)
        .first();
    },
  },
  watch: {
    mainMandate(newVal, oldVal) {
      if (!this.$_.isEqual(newVal, oldVal)) {
        this.mainMandateData = newVal;
      }
    },
    resolutionVote(newVal, oldVal) {
      if (!this.$_.isEqual(newVal, oldVal)) {
        this.resolutionVoteData = newVal;
      }
    },
    currentResolution(newVal, oldVal) {
      if (!this.$_.isEqual(newVal, oldVal)) {
        this.currentResolutionData = newVal;
      }
    },
  },
  created() {
    this.currentResolutionData = this.currentResolution;
    this.mainMandateData = this.mainMandate;
    this.resolutionVoteData = this.resolutionVote;
    this.representsOtherMandates = this.checkIfRepresentsOtherMandates();
    this.presentParticipant = this.checkIfPresentParticipant();
  },
  methods: {
    checkIfPresentParticipant() {
      if (this.mainMandateData.representant_owner_id) {
        return this.mainMandateData.building_owner_id == this.mainMandateData.representant_owner_id;
      } else if (this.mainMandateData.representant_contact_id) {
        return true;
      }
      return false;
    },
    checkIfRepresentsOtherMandates() {
      return MandateORM.getters("checkIfRepresentsOtherMandates")(this.mainMandateData);
    },

    updateResolutionVote(key, value) {
      this.$store.state.showLoaderOverlay = true;
      if (this.resolutionVote) {
        // NOTE: This is only for correspondence table vote
        if (this.mainMandateData.presence_status == this.mandatePresenceStatuses.correspondence) {
          let currentMajority =
            this.currentResolution.revote_majority_id == null
              ? this.currentResolution.majority_id
              : this.currentResolution.revote_majority_id;
          let proposedVotes = this.meetingCorrespondenceVotes.proposed_votes;
          if (proposedVotes && proposedVotes.length > 0) {
            let proposedVoteIndex = this.$_.findIndex(proposedVotes, item => {
              return (
                item.meeting_resolution_id == this.currentResolution.id &&
                item.majority_id == currentMajority
              );
            });
            proposedVotes[proposedVoteIndex].vote = value;
            MeetingCorrespondenceVoteORM.update({
              where: this.meetingCorrespondenceVotes.id,
              data: {
                proposed_votes: proposedVotes,
              },
            });
          }
        }
        ResolutionVoteORM.update({
          where: this.resolutionVote.id,
          data: { [key]: value, presence_status: this.mainMandateData.presence_status },
        });

        let rv = { ...this.resolutionVote };
        rv.vote = value;
        ResolutionVoteMW.PUT(rv, false)
          .then(() => {
            this.$store.state.showLoaderOverlay = false;
            // NOTE: This is only for correspondence table vote
            if (
              this.mainMandateData.presence_status == this.mandatePresenceStatuses.correspondence
            ) {
              MeetingCorrespondenceVoteMW.PUT(this.meetingCorrespondenceVotes);
            }
          })
          .catch(err => {
            this.$store.state.showLoaderOverlay = false;
            console.error(err);
            this.$swal(this.alertError());
          });
      } else {
        this.CREATE_RESOLUTION_VOTE(value);
      }
    },
    CREATE_RESOLUTION_VOTE(value) {
      var presence_status = this.mainMandateData.presence_status;
      this.$store.state.showLoaderOverlay = true;

      var resolutionVote = {
        mandate_id: this.mainMandateData.id,
        meeting_has_resolution_id: this.currentResolutionData.id,
        // ..
        vote: value,
        presence_status,
        agency_id: Number(localStorage.getItem("agencyId")),
      };

      ResolutionVoteMW.POST(resolutionVote)
        .then(() => {
          this.$store.state.showLoaderOverlay = false;
        })
        .catch(err => {
          this.$store.state.showLoaderOverlay = false;
          console.error(err);
          this.$swal(this.alertError());
        });
    },
    // NOTE: select for all the mandates he represents
    async selectAllRepresentedVotes(type) {
      try {
        this.$store.state.showLoaderOverlay = true;

        var voteType = type;

        var hisRepresentedMandates = this.$_.filter(this.mandates, mandate => {
          if (this.mainMandateData.representant_owner_id) {
            return (
              mandate.representant_owner_id == this.mainMandateData.representant_owner_id &&
              mandate.building_owner_id !== this.mainMandateData.building_owner_id
            );
          } else if (this.mainMandateData.representant_contact_id) {
            return (
              mandate.representant_contact_id == this.mainMandateData.representant_contact_id &&
              mandate.building_owner_id !== this.mainMandateData.building_owner_id
            );
          }
        });

        // prepare post object for web api
        var bulkVotePostObj = this.prepareBulkVotePostObj(
          voteType,
          hisRepresentedMandates,
          this.currentResolutionData.id
        );

        await ResolutionVoteMW.BULK_VOTE(bulkVotePostObj).then(async () => {
          // ???:
          await ResolutionVoteMW.FETCH(this.currentResolutionData.id);
          this.$store.state.showLoaderOverlay = false;
        });
      } catch {
        this.$swal(this.alertError());
        this.$store.state.showLoaderOverlay = false;
      }
    },
  },
};
</script>
